export default {
      id: "icon-linkedin-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "icons.svg#icon-linkedin",
      toString: function () {
        return this.url;
      }
    }